import { render, staticRenderFns } from "./catalog-desktop-second-categories-list.vue?vue&type=template&id=6f226310&"
import script from "./catalog-desktop-second-categories-list.vue?vue&type=script&lang=js&"
export * from "./catalog-desktop-second-categories-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  ,true
)

export default component.exports